export const RELATIVES_PAGE_SIZE = 20;
